import { Grid as MuiGrid } from '@mui/material';

import { BasetenPageEnum } from '@/routes';

import GridCardWrapper from '../../sections/GridCardWrapper';
import { GridContainer } from '../../styled';
import { ListProps } from '../types';
import Card from './Card';

function Grid({ models, isPinned }: ListProps) {
  return (
    <GridContainer px={4} py={2}>
      <MuiGrid container spacing={3}>
        {models.map((model) => (
          <GridCardWrapper<BasetenPageEnum.Model>
            linkParams={{ page: BasetenPageEnum.Model, params: { modelId: model.id } }}
            key={model.id}
            alwaysVisible={models.length < 35}
            containerSx={{
              minHeight: 120,
            }}
          >
            <Card model={model} />
          </GridCardWrapper>
        ))}
      </MuiGrid>
    </GridContainer>
  );
}

export default Grid;
